export default async function (status: boolean) {
  if (status === true) {
    await document.documentElement.requestFullscreen();
    return;
  }
  if (document.exitFullscreen) {
    await document.exitFullscreen();
  }
}
